import "./App.css";
import { Main } from "./Main";

function App() {
  return (
    <div className="AppWrapper">
      <Main />
    </div>
  );
}

export default App;
